import { ref } from 'vue'

const isSlidingChatVisible = ref(false)
const slidingChatInitialChatId = ref<number | null>(null)
const slidingChatInitialUserId = ref<string | null>(null)

export function useSlidingChatGlobal() {
  const openSlidingChat = (chatId?: number | null, userId?: string | null) => {
    slidingChatInitialChatId.value = chatId || null
    slidingChatInitialUserId.value = userId || null
    isSlidingChatVisible.value = true
  }

  const closeSlidingChat = () => {
    isSlidingChatVisible.value = false
    slidingChatInitialChatId.value = null
    slidingChatInitialUserId.value = null
  }

  return {
    isSlidingChatVisible,
    slidingChatInitialChatId,
    slidingChatInitialUserId,
    openSlidingChat,
    closeSlidingChat,
  }
}
